angular.module("showCervedInfosPv.components", [])
    .component("showCervedInfosPv", {
        templateUrl: "ng/components/riscattoAnticipato/showCervedInfosPv/showCervedInfosPv.view.html",
        bindings: {
            model: "<",
            riUserGFromCerved: "<",
            onBack: "&",
            onInsert: "&",
            waitCervedUpdate: "<",
            showBackButton: "<",
            isCessioneVoltura: "=",
            isLo: '<',
            updateDataFromCervedLo: '&',
            hideButtons: "<",
            modifyTitleNsil: "<"

        },
        controllerAs: "showCervedInfosPvCtrl",
        controller: showCervedInfosPvController
    });

function showCervedInfosPvController(
    $financialApiService,
    $scope,
    $typeDomainService,
    $rootScope,
    $simulationService,
    $giuridicVersion,
    FinancialCustomer,
    es6Factory
) {
    var self = this;
    self.supportModel = {
        riUserGFromCerved: jQuery.extend(true, {}, self.riUserGFromCerved),
        dropdown: {
            legalStatuses: [],
            sae: [],
            rae: []
        }
    }

    self.$onInit = function () {
        self.$rootScope = $rootScope;
        self.showAlert = false;
        self.documentDate = {
            disabledDays: [0],
            disabledDates: ["01-01",
                "06-01",
                "25-04",
                "01-05",
                "02-06",
                "15-08",
                "01-11",
                "08-12",
                "25-12",
                "26-12"
            ]
        }
        getListOfProv();
        popolateLegalStatus();
        listOfLegalStatusNotDataAvvioAttivita()
    };

    self.$onChanges = function (changed) {

        if (changed.riUserGFromCerved && changed.riUserGFromCerved.currentValue) {
            self.supportModel.riUserGFromCerved = jQuery.extend(true, {}, changed.riUserGFromCerved.currentValue)
            if (self.riUserGFromCerved && self.riUserGFromCerved.formaGiuridica) {
                self.getSaeByLegalStatus(self.riUserGFromCerved.formaGiuridica);
            }
            if (self.riUserGFromCerved && self.riUserGFromCerved.sae) {
                self.getRaeBySae(self.riUserGFromCerved.sae);
            }
            //in caso di cciaapv non valida
            if (changed.riUserGFromCerved.currentValue.cciaaPvInvalid) {
                self.InvalidProv = changed.riUserGFromCerved.currentValue.cciaaPv;
                changed.riUserGFromCerved.currentValue.cciaaPv = "";
            }
        }
        if (!self.supportModel.riUserGFromCerved.cciaaPv) {
            self.cciaaPvIsEmpty = true;
        } else {
            self.cciaaPvIsEmpty = false;
        }
    }

    self.saveUpdatedData = function () {

        if (self.isCessioneVoltura || self.isLo) {
            self.onInsert({
                riUserG: self.riUserGFromCerved
            });
            self.onBack();
        } else {
            if (!self.supportModel.riUserGFromCerved.ateco || !self.supportModel.riUserGFromCerved.sae || !self.supportModel.riUserGFromCerved.rae) {
                self.restCalling = true;
                $simulationService
                    .checkSaeRaeAteco(self.riUserGFromCerved.sae, self.riUserGFromCerved.rae, self.riUserGFromCerved.ateco, self.riUserGFromCerved.formaGiuridica, self.riUserGFromCerved.cf, self.riUserGFromCerved.piva)
                    .then(function (response) {
                        if (response.success) {
                            self.riUserGFromCerved.ateco = response.ateco;
                            self.onInsert({
                                riUserG: self.riUserGFromCerved
                            });
                            self.onBack();
                            self.restCalling = false;
                            $financialApiService
                                .getSaveAppCustomer(FinancialCustomer.build(self.model))
                                .then(function (saveAppCustomerResp) {
                                    if (saveAppCustomerResp) {
                                        console.log("SaveAppCustomerUser success: ", saveAppCustomerResp);
                                    }
                                });

                        } else {
                            self.restCalling = false;
                            $rootScope.$broadcast("addAlert", {
                                text: "ERROR_ATECO_SAE_RAE"
                            });
                        }
                    })

            } else {
                self.onInsert({
                    riUserG: self.riUserGFromCerved
                });
                self.onBack();

                $financialApiService
                    .getSaveAppCustomer(self.model)
                    .then(function (saveAppCustomerResp) {
                        if (saveAppCustomerResp) {
                            console.log("SaveAppCustomerUser success: ", saveAppCustomerResp);
                        }
                    });
            }
        }
    };

    self.discardUpdatedData = function () {
        self.onBack();
    };

    self.enableConfirm = function () {
        var checkIfStuFormG = true;

        if (self.riUserGFromCerved && self.riUserGFromCerved.formaGiuridica === 'STU') {
            checkIfStuFormG = !!self.riUserGFromCerved.dataAvvioAttivita
        }

        if (self.hideButtons) {

            var test = $scope.showCervedForm &&
                $scope.showCervedForm.$valid &&
                !!self.riUserGFromCerved &&
                !!self.riUserGFromCerved.formaGiuridica &&
                !!self.riUserGFromCerved.sae &&
                !!self.riUserGFromCerved.rae &&
                !self.showErrorFormaGiuridica &&
                checkIfStuFormG;

            self.riUserGFromCerved.datiIncompleti = !test;
            self.onInsert({
                riUserG: self.riUserGFromCerved
            });
            return test;

        } else {
            return $scope.showCervedForm &&
                $scope.showCervedForm.$valid &&
                !!self.riUserGFromCerved &&
                !!self.riUserGFromCerved.formaGiuridica &&
                !!self.riUserGFromCerved.sae &&
                !!self.riUserGFromCerved.rae &&
                !self.showErrorFormaGiuridica &&
                checkIfStuFormG;

        }


    }

    var popolateLegalStatus = function () {

        $typeDomainService.getAllLegalStatuses()
            .then(function (response) {
                self.supportModel.dropdown.legalStatuses = response;
                self.supportModel.waitLegalStatus = false;
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    self.getSaeByLegalStatus = function (legalStatus, fromViewHtml) {

        if (fromViewHtml) {
            self.riUserGFromCerved.sae = ""
        }

        if (legalStatus === "PEF") {
            self.riUserGFromCerved.piva = null;
        }

        if ($giuridicVersion.checkIfInd(legalStatus) && es6Factory.isNumeric(self.riUserGFromCerved.cf)) {
            self.showErrorFormaGiuridica = true;
        } else {
            self.showErrorFormaGiuridica = false;
        }
        self.supportModel.riUserGFromCerved = jQuery.extend(true, {}, self.riUserGFromCerved);
        $typeDomainService
            .getSaeByLegalStatus(legalStatus)
            .then(function (saeList) {
                self.supportModel.dropdown.sae = saeList;
                self.supportModel.waitSae = false;

            });

        checkIfVisibleDataAvvioAttivita()
    };

    self.getRaeBySae = function (sae, fromViewHtml) {

        if (fromViewHtml) {
            self.riUserGFromCerved.rae = ""
        }
        self.supportModel.riUserGFromCerved = self.riUserGFromCerved;
        $typeDomainService
            .getRaeBySae(sae)
            .then(function (raeList) {
                self.supportModel.dropdown.rae = raeList;
                self.supportModel.waitRae = false;
            });
    };

    self.getLegalStatusDescription = function (legalStatusCode) {
        if (self.supportModel.dropdown.legalStatuses && legalStatusCode) {
            var result = self.supportModel.dropdown.legalStatuses.find(function (legalStatus) {
                return legalStatus.id == legalStatusCode.toUpperCase()
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';
    }

    self.getSaeDescription = function (saeCode) {

        if (self.supportModel.dropdown.sae) {
            var result = self.supportModel.dropdown.sae.find(function (sae) {
                return sae.id == saeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';

    }

    self.getRaeDescription = function (raeCode) {

        if (self.supportModel.dropdown.rae) {
            var result = self.supportModel.dropdown.rae.find(function (rae) {
                return rae.id == raeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';

    }

    self.cervedInfoChanged = function (poperty, value) {

        if (poperty == 'inputCF' && $giuridicVersion.checkIfInd(self.riUserGFromCerved.formaGiuridica) && es6Factory.isNumeric(value)) {
            self.showErrorFormaGiuridica = true;
        } else {
            self.showErrorFormaGiuridica = false;
        }

        if (poperty == 'inputCF') {
            self.riUserGFromCerved.cf = self.riUserGFromCerved.cf && self.riUserGFromCerved.cf.toUpperCase();
        }

    }

    var getListOfProv = function () {
        self.listaProvince = $rootScope.comuniMap.map(function (comune) {
            return comune.sigla;
        })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);
    }

    var listOfLegalStatusNotDataAvvioAttivita = function () {
        $typeDomainService.getDomainSet('FORMA_GIURIDICA', 'NO_DATA_AVVIO_ATTIVITA')
            .then(function (response) {
                self.listOfFreeLegalStatus = response.domainList;
            })
    }

    var checkIfVisibleDataAvvioAttivita = function () {

        self.showHideDataAvvioAttivita = self.listOfFreeLegalStatus &&
            self.listOfFreeLegalStatus.some(
                function (element) {
                    return element.value == self.riUserGFromCerved.formaGiuridica
                })
        return self.showHideDataAvvioAttivita;
    }

    self.checkpIvaAssente = function (el) {
        self.riUserGFromCerved.pIvaAssente = !self.riUserGFromCerved.pIvaAssente;
        if (self.riUserGFromCerved.pIvaAssente) {
            self.showAlert = true;
        } else {
            self.showAlert = false;
        }
    }

    self.getUpdatedDataFromCerved = function () {
        self.updateDataFromCervedLo()
    }

    self.changedDate = function (tipo, value) {
        self.riUserGFromCerved[tipo] = value;
    }
}